import { useContext, useEffect, useState } from "react";
import { motion } from "framer-motion";
import {
    Box, Card, Stack, Typography, Chip, Button, CircularProgress,
} from "@mui/joy";
import DescriptionRoundedIcon from "@mui/icons-material/DescriptionRounded";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";

import { LayoutContext } from "../../context";
import { APIClientDocuments, documentSharedUrl } from "../../api";

const TYPE_LABEL = { invoice: "Счёт на оплату", upd: "УПД", contract: "Договор" };
const STATUS = {
    formed:   { label: "Готов",     color: "primary" },
    verified: { label: "Проверен",  color: "warning" },
    sent:     { label: "Отправлен", color: "success" },
    signed:   { label: "Подписан",  color: "success" },
    paid:     { label: "Оплачен",   color: "success" },
};

export default function DocumentsPage() {
    const { account } = useContext(LayoutContext);   // eslint-disable-line no-unused-vars
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let alive = true;
        setLoading(true);
        APIClientDocuments().then((d) => {
            if (!alive) return;
            setItems(Array.isArray(d?.results) ? d.results : []);
            setLoading(false);
        });
        return () => { alive = false; };
    }, []);

    const open = (d) => {
        if (d.share_token) window.open(documentSharedUrl(d.share_token), "_blank");
        else if (d.pdf_url) window.open(d.pdf_url, "_blank");
    };

    return (
        <Box sx={{ maxWidth: 1200, mx: "auto", px: { xs: 2, sm: 3 }, py: 3, pb: 8 }}>
            <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.3 }}>
                <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 3 }}>
                    <DescriptionRoundedIcon sx={{ fontSize: 28, color: "primary.500" }} />
                    <Typography level="h2" fontWeight={800}>Документы</Typography>
                </Stack>

                {loading ? (
                    <Stack alignItems="center" sx={{ py: 6 }}><CircularProgress /></Stack>
                ) : items.length === 0 ? (
                    <Card variant="outlined" sx={{ borderRadius: "20px", p: 4, textAlign: "center", color: "text.tertiary" }}>
                        Документов пока нет. Они появятся после оформления заявки и завершения замера.
                    </Card>
                ) : (
                    <Stack spacing={1.5}>
                        {items.map((d) => {
                            const st = STATUS[d.status] || { label: d.status, color: "neutral" };
                            return (
                                <Card key={d.id} variant="outlined" sx={{ borderRadius: "16px", p: 2 }}>
                                    <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ gap: 1, flexWrap: "wrap" }}>
                                        <Box sx={{ minWidth: 0 }}>
                                            <Stack direction="row" spacing={1} alignItems="center" sx={{ flexWrap: "wrap" }}>
                                                <Typography level="title-sm" fontWeight={800}>
                                                    {TYPE_LABEL[d.doc_type] || d.doc_type} № {d.number || d.id}
                                                </Typography>
                                                <Chip size="sm" variant="soft" color={st.color} sx={{ borderRadius: 8 }}>{st.label}</Chip>
                                            </Stack>
                                            <Typography level="body-xs" sx={{ color: "text.tertiary", mt: 0.3 }}>
                                                {d.total_amount} ₽{d.date ? ` · ${d.date}` : ""}{d.deal_id ? ` · заявка №${d.deal_id}` : ""}
                                            </Typography>
                                        </Box>
                                        <Button size="sm" variant="soft" color="primary" startDecorator={<OpenInNewRoundedIcon />}
                                                onClick={() => open(d)} sx={{ borderRadius: 12, fontWeight: 700 }}>
                                            Открыть
                                        </Button>
                                    </Stack>
                                </Card>
                            );
                        })}
                    </Stack>
                )}
            </motion.div>
        </Box>
    );
}